import styled from "styled-components";
import { mediaMax } from "components/designV2/breakpoints";
import { FieldCard } from "web-apps/company/components/staff/components/profilePanel/layout/profilePanel.styled";

export const EmployeeNumberFieldCard = styled(FieldCard)`
  grid-column: 1;

  & > div > label {
    display: block;
    min-height: 42px;
  }

  ${mediaMax.mobile} {
    grid-column: auto;
  }
`;

export const RoleFieldCard = styled(FieldCard)`
  grid-column: 2;

  & > div > label {
    display: block;
    min-height: 42px;
  }

  ${mediaMax.mobile} {
    grid-column: auto;
  }
`;
